export default {
    inquiry: 'คำร้องขอ',
    inquiryInTd: 'คำขอ',
    name: 'ชื่อ',
    employeeNo: 'รหัสพนักงาน',
    approve: 'อนุมัติ',
    reject: 'ไม่อนุมัติ',
    inquiryMessage: 'ไม่พบข้อมูลการขอลาหรือขอไปทำงานนอกสถานที่ของวันที่ ',
    mon: 'จ.',
    tues: 'อ.',
    wednes: 'พ.',
    thurs: 'พฤ.',
    fri: 'ศ.',
    satur: 'ส.',
    sun: 'อา.',
    congratulation: 'ยินดีดัวย',
    applicationStatus: 'สถานะการร้องขอของ',
    isUpdated: 'ถูกอัปเดตแล้ว'
}
